/**
 * Labstep
 *
 * @module components/User/Table
 * @desc Table listing all users
 */

import { EntityLinkComponent } from 'labstep-web/components/Entity/Link/Component';
import { EntityTableParamsContainer as EntityTable } from 'labstep-web/components/Entity/Table';
import PermissionRoleActionViewAll from 'labstep-web/components/PermissionRole/Action/ViewAll';
import Profile from 'labstep-web/components/User/Show/Profile';
import { UserGroupActionUpdate } from 'labstep-web/components/UserGroup/Action/Update';
import { Hoverable } from 'labstep-web/core/Hoverable';
import type { UserGroup } from 'labstep-web/models/user-group.model';
import type React from 'react';
import type { UserTableProps } from './types';

export const UserTable: React.FC<UserTableProps> = ({
  userGroups,
  actionMenu,
  ...rest
}) => {
  return (
    <EntityTable
      {...rest}
      id="user-table"
      primaryColumn={{
        header: 'Name',
        content: (userGroup) => (
          <Profile
            user={userGroup.user}
            viewComponent={
              <EntityLinkComponent entity={userGroup.user} />
            }
          />
        ),
        cellProps: { style: { flex: 2 } },
      }}
      extraColumns={[
        {
          header: 'Workspace Role',
          content: (userGroup: UserGroup) => (
            <Hoverable
              hoverable={
                <UserGroupActionUpdate userGroup={userGroup} />
              }
              component={<PermissionRoleActionViewAll />}
            />
          ),
          cellProps: { style: { flex: 2 } },
        },
      ]}
      entities={userGroups}
      actionMenu={actionMenu}
    />
  );
};
